import styled from 'styled-components';
import { HiddenElement } from '@/styles/helpers';
import { DesktopFooter as _DesktopFooter, Footer } from '@/components/Footer';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: ${({ theme }) => theme.palette.primary.background};
`;

export const DesktopFooter = styled(_DesktopFooter)<{ $isVisible: boolean }>`
  ${({ $isVisible }) => !$isVisible && HiddenElement}
  margin-top: 40px;
  width: 100%;
  padding: 40px calc((100% - 1000px) / 2 + 20px) 25px;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 40px max(40px, calc((100% - 1000px) / 2 + 40px)) 25px;
  }
`;

export const MobileFooter = styled(Footer)<{ $isVisible: boolean }>`
  ${({ $isVisible }) => !$isVisible && HiddenElement}
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-top: 60px;
  }
`;

export const PopularRequestsBox = styled.div<{ $isVisibile: boolean }>`
  ${({ $isVisibile }) => !$isVisibile && HiddenElement}
`;
